import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../lib/i18n";
import { LEGAL } from "../lib/legalContent";

export default function Legal() {
  const { doc } = useParams();
  const nav = useNavigate();
  const { lang } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, [doc]);
  const L = (LEGAL[lang] || LEGAL.fr);
  const key = ["mentions", "privacy", "terms", "sales", "cookies"].includes(doc) ? doc : "mentions";
  const page = L[key];

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white lb-grid-bg">
      <div className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        <button onClick={() => nav(-1)} data-testid="legal-back" className="inline-flex items-center gap-1.5 text-sm text-[hsl(var(--muted-foreground))] hover:text-white mb-6"><ArrowLeft size={15} /> LOCALBOOST AI</button>
        <h1 className="font-display font-black text-3xl sm:text-4xl mb-2" data-testid="legal-title">{page.title}</h1>
        <p className="text-xs text-[hsl(var(--muted-foreground))] mb-1">{L.updated}</p>
        <p className="text-xs text-[hsl(var(--muted-foreground))] italic mb-8">{L.disclaimer}</p>
        <div className="space-y-6">
          {page.sections.map((s, i) => (
            <section key={i} className="lb-card p-5" data-testid={`legal-section-${i}`}>
              <h2 className="font-display font-bold text-lg mb-2">{s.h}</h2>
              <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed whitespace-pre-line">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
